import { Modal, Button } from "antd";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import styles from "./kitRequestModal.module.scss";

const STATE_ICON = {
	confirm: <ExclamationCircleFilled />,
	success: <CheckCircleFilled />,
	error: <CloseCircleFilled />,
};

const KitRequestModal = ({ open, state = "confirm", title, description, buttonText, loading = false, onClose, onAction }) => {
	return (
		<Modal open={open} onCancel={onClose} footer={null} centered width={340} className={styles.kitRequestModal}>
			<div className={`${styles.holderResult} ${styles[state] || ""}`}>
				<div className={styles.icon}>{STATE_ICON[state]}</div>
				<h3>{title}</h3>
				<p>{description}</p>
				<Button className="btn-normal btn-aptel" loading={loading} onClick={onAction}>
					{buttonText}
				</Button>
			</div>
		</Modal>
	);
};

export default KitRequestModal;
